import { State } from "@/stores/notification/type.ts";

export default {
  notificationSettingsData: (state: State) => state.notificationSettings,
};
